import { FunctionComponent } from 'react'
import { Switch } from 'react-router-dom'

import Route from '../../../shared/routes/Route'
import { ListMotoristaFactory } from '../factories/ListMotoristas'
import { DetalhesViagemFactory } from '../factories/DetalhesViagem'
import { ListViagensFactory } from '../factories/ListViagens'

const ValePedagioRoutes: FunctionComponent = () => {
  return (
    <Switch>
      <Route
        path="/vale-pedagio"
        isPrivate
        exact
        component={ListMotoristaFactory}
      />
      <Route
        path="/vale-pedagio/viagens"
        isPrivate
        exact
        component={ListViagensFactory}
      />
      <Route
        path="/vale-pedagio/detalhes"
        isPrivate
        exact
        component={DetalhesViagemFactory}
      />
    </Switch>
  )
}

export default ValePedagioRoutes
